export const FROZEN_EMPTY_ARRAY = Object.freeze([]);
export const FROZEN_EMPTY_OBJECT = Object.freeze({});
